import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CONSTANTS_DETAILS } from '../../shared';
import { catchError, map, of } from 'rxjs';
import { TranslateLoader } from '@ngx-translate/core';
import { SnackbarService } from '../snackbar/snackbar.service';

type TranslationKeyValueModel = Record<string, string>;

@Injectable({
  providedIn: 'root',
})
export class AppTranslateLoaderFactoryService implements TranslateLoader {
  constructor(
    private _http: HttpClient,
    private _snackbarService: SnackbarService,
  ) {
    this.getTranslation('en');
  }
  /**
   * Fetches translation data from the server.
   *
   * @private
   * @memberof AppTranslateLoaderFactoryService
   */
  public getTranslation(lang: string) {
    return this._http
      .get<{
        translationTokens: TranslationKeyValueModel;
      }>(
        `${environment.APP_BASE_URL}${CONSTANTS_DETAILS.GET_TRANSLATION}?langKey=${lang}`,
      )
      .pipe(
        map((response) => {
          return response.translationTokens || {};
        }),
        catchError(() => {
          this._snackbarService.open({
            message: 'Error fetching translations',
            type: 'error',
          });
          return of({});
        }),
      );
  }
}
